const state = {
  year: 2011,
};

const mutations = {
  resetYear(state) {
    state.year = 2011;
  },
  setYear(state) {
    state.year++;
  },
};

const actions = {
  resetYear({ commit }) {
    commit('resetYear');
  },
  updateYear({ commit }) {
    commit('setYear');
  },
};

const getters = {
  currentYear: state => state.year,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
